// extracted by mini-css-extract-plugin
module.exports = {"sim-logo-container":"simLogo_sim-logo-container__6ryVW","sim-logo":"simLogo_sim-logo__2SgxW","sim-name":"simLogo_sim-name__3o2lB","sim-image":"simLogo_sim-image__2wU6u"};